import { Factory } from "lucide-react";
import { eur, monthLabel } from "./format";

export const TopSuppliers = ({ rows, month, totalCost }) => (
  <div className="min-w-0 rounded-2xl bg-slate-900/70 ring-1 ring-white/5" data-testid="top-suppliers">
    <div className="flex items-start justify-between gap-3 border-b border-white/5 p-5">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">Top suppliers</p>
        <p className="mt-0.5 text-sm text-slate-500">Purchase orders raised against orders written in {monthLabel(month)}</p>
      </div>
      <span className="flex items-center gap-1.5 rounded-full bg-rose-500/15 px-3 py-1 font-mono text-sm font-bold text-rose-300 ring-1 ring-rose-500/30" data-testid="top-suppliers-total">
        <Factory className="h-4 w-4" /> {eur(totalCost)}
      </span>
    </div>
    {rows.length === 0 ? (
      <p className="px-5 py-8 text-center text-sm text-slate-500" data-testid="top-suppliers-empty">No supplier POs on this month's orders.</p>
    ) : (
      <ul className="divide-y divide-white/5" data-testid="top-suppliers-list">
        {rows.map((s) => (
          <li key={s.supplier} className="px-5 py-3" data-testid={`supplier-row-${s.supplier.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
            <div className="flex items-center justify-between gap-3 text-sm">
              <span className="min-w-0 truncate font-medium text-slate-100" title={s.supplier}>{s.supplier}</span>
              <span className="shrink-0 font-mono font-semibold text-rose-200">{eur(s.spend)}</span>
            </div>
            <div className="mt-1.5 flex items-center gap-3">
              <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-slate-800">
                <div className="h-full rounded-full bg-rose-400/80 transition-[width] duration-500" style={{ width: `${Math.max(2, s.share_pct)}%` }} />
              </div>
              <span className="shrink-0 text-xs text-slate-500">{s.po_count} PO{s.po_count === 1 ? "" : "s"} · {s.job_count} job{s.job_count === 1 ? "" : "s"} · {s.share_pct}%</span>
            </div>
          </li>
        ))}
      </ul>
    )}
  </div>
);
